import {
  Textarea as BaseTextarea,
  TextAreaProps as BaseTextareaProps,
  extendVariants,
} from '@heroui/react';

export const Textarea = extendVariants(BaseTextarea, {
  variants: {
    color: {
      white: {
        inputWrapper: 'bg-white data-[hover=true]:bg-background',
      },
    },
  },
});

export type TextareaProps = Omit<BaseTextareaProps, 'color'> & {
  color?: BaseTextareaProps['color'] | 'white';
};
